import React from "react";

const ServicesIntroduction = ({ projectIntroductionData }) => {
  return (
    <section className="intro-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <div className="htit">
              <h4>
                <span>01 </span> Introduction
              </h4>
            </div>
          </div>
          <div className="col-lg-8 offset-lg-1 col-md-8">
            <div className="text js-scroll__content">
              <h3 className="mb-4">
                {projectIntroductionData?.titleDescription}
              </h3>
              <div className="extra-text">
                <p
                  dangerouslySetInnerHTML={{
                    __html: projectIntroductionData?.description,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesIntroduction;
